@use './variables' as *;

:host {
  display: $business-class-host-display;
}

.business-class {
  display: $business-class-display;
  flex-direction: $business-class-flex-direction;
}

.input-hint {
  position: $business-class-input-hint-position;
  right: $business-class-input-hint-right;
  line-height: $business-class-input-hint-line-height;
  pointer-events: $business-class-input-hint-pointer-events;
  color: $business-class-input-hint-color;
}

air-button {
  width: $business-class-button-width;
}

// RESULTS
.results-header-wrapper {
  display: $business-class-results-header-wrapper-display;
  flex-direction: $business-class-results-header-wrapper-flex-direction;
  justify-content: $business-class-results-header-wrapper-justify-content;
  align-items: $business-class-results-header-wrapper-align-items;
  height: $business-class-results-header-wrapper-height;
  margin-top: $business-class-results-header-wrapper-margin-top;
  margin-bottom: $business-class-results-header-wrapper-margin-bottom;
}

.results-header-title {
  color: $business-class-results-header-title-color;
  font-style: $business-class-results-header-title-font-style;
  font-weight: $business-class-results-header-title-font-weight;
  font-size: $business-class-results-header-title-font-size;
  line-height: $business-class-results-header-title-line-height;
  font-family: $business-class-results-header-title-font-family;
}

.no-results {
  margin-top: $business-class-no-results-margin-top;
  color: $business-class-no-results-color;
  font-style: $business-class-no-results-font-style;
  font-weight: $business-class-no-results-font-weight;
  font-size: $business-class-no-results-font-size;
  line-height: $business-class-no-results-line-height;
  font-family: $business-class-no-results-font-family;
}

.results-header-counter {
  color: $business-class-results-header-counter-color;
  font-style: $business-class-results-header-counter-font-style;
  font-weight: $business-class-results-header-counter-font-weight;
  font-size: $business-class-results-header-counter-font-size;
  line-height: $business-class-results-header-counter-line-height;
  font-family: $business-class-results-header-counter-font-family;
  text-align: $business-class-results-header-counter-text-align;
}

.results-dismiss-link {
  display: $business-class-results-dismiss-link-display;
  margin-top: $business-class-results-dismiss-link-margin-top;
}

.results-footer air-divider {
  margin-top: $business-class-results-footer-divider-margin-top;
  margin-bottom: $business-class--results-footer-divider-margin-bottom;
}

// LINKS
air-link {
  display: $business-class-link-display;
  flex-direction: $business-class-link-flex-direction;
  align-items: $business-class-link-align-items;
}

.air-link air-icon {
  margin-right: $business-class-link-icon-margin-right;
}

.air-link {
  font-family: $business-class-link-font-family;
  text-decoration: $business-class-link-text-decoration;
  color: $business-class-link-color;
  flex-direction: $business-class-link-flex-direction;
  display: $business-class-link-display;
  align-items: $business-class-link-align-items;
  width: $business-class-link-width;
}

.air-link:visited {
  color: $business-class-link-visited-color;
}

.air-link:hover {
  color: $business-class-link-hover-color;
  cursor: $business-class-link-hover-cursor;
}

.air-link:focus {
  color: $business-class-link-focus-color;
  outline: $business-class-link-focus-outline;
}

.air-link:active {
  color: $business-class-link-active-color;
}

.business-class-card-caption {
  color: $business-class-results-card-caption-color;
  font-style: $business-class-results-card-caption-font-style;
  font-weight: $business-class-results-card-caption-font-weight;
  font-size: $business-class-results-card-caption-font-size;
  line-height: $business-class-results-card-caption-line-height;
  font-family: $business-class-results-card-caption-font-family;
}

.error air-business-class-card {
  --air-business-class-card-border: 1px solid var(--air-color-error, #e55451);
}

.result-selected air-business-class-card {
  --air-business-class-card-background: var(--air-color-snow, #fbfafa);
  --air-business-class-card-border: 2px solid var(--air-color-eclipse, #3a3a3a);
  --air-business-class-card-hover-border: 2px solid var(--air-color-eclipse, #3a3a3a);
  --air-business-class-card-hover-title-color: var(--air-color-eclipse, #3a3a3a);
  --air-business-class-card-hover-title-font-weight: var(
    --air-business-class-card-title-font-weight
  );
  --air-business-class-card-hover-title-text-decoration-line: none;
}
